module.exports = __webpack_public_path__ + "img/upload.3b816521.svg";